<template>
  <div class="home-container">
    <div class="hx-breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>党费系统</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ name : 'paymentMonth' }">缴费月份</el-breadcrumb-item>
        <el-breadcrumb-item>缴费月份详情</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="hx-form-container box-shadow" v-loading="detailLoading">
      <div class="detail-info-layout">
        <h1 v-if="listParams.status === 1" class="status-style text-green">开放</h1>
        <h1 v-else class="status-style text-red">关闭</h1>
        <div class="mgl15">
          <div class="form-label-style">
            <label>缴费月份：</label>
            <span>{{ listParams.paymentMonth }}</span>
          </div>
          <div class="form-label-style">
            <label>实收金额：</label>
            <span class="text-red">{{ listParams.payment | formatToFixed2('元') }}</span>
          </div>
          <div class="form-label-style">
            <label>缴费人数：</label>
            <span class="text-red">{{ listParams.paymentMember }}/{{ listParams.allMember }}</span>
          </div>
          <div class="form-label-style">
            <label>缴费截止日期：</label>
            <span>{{ listParams.endDate }}</span>
          </div>
        </div>
      </div>
    </div>

    <hx-table-result
      :page-info="pager"
      :loading="tableLoading"
      @page-current-change="handleCurrentChange"
      @page-size-change="handleSizeChange">

      <div slot="action"></div>

      <hx-table-result-col>
        <div class="wrap-table-info-display">
          <el-radio-group
            v-model="paymentStatus"
            class="mgt10"
            @change="changeRadio">
            <el-radio :label="0">全部</el-radio>
            <el-radio :label="1">已缴费</el-radio>
            <el-radio :label="2">未缴费</el-radio>
          </el-radio-group>
          <span class="table-info-display">
            <el-button
              :disabled="isDisabled"
              @click="remindPayment"
              size="small"
              style="width: 200px;"
              type="primary">
              一键提醒
            </el-button>
            <span>总条数：</span>
            <span class="alert-text ft16">{{ pager.total }}</span>
          </span>
        </div>
      </hx-table-result-col>

      <el-table
        slot="content"
        :data="tableData"
        max-height="800"
        border>
        <el-table-column
          prop="paymentStatus"
          align="center"
          label="缴费状态">
          <template slot-scope="scope">
            <span v-if="scope.row.paymentStatus === 1" style="color: green;">已缴费</span>
            <span v-if="scope.row.paymentStatus === 2" style="color: red;">未缴费</span>
          </template>
        </el-table-column>

        <el-table-column
          prop="partyMember"
          align="center"
          label="人员">
        </el-table-column>

        <el-table-column
          prop="phoneNumber"
          align="center"
          label="手机号">
        </el-table-column>

        <el-table-column
          prop="groupName"
          align="center"
          label="分组">
        </el-table-column>

        <el-table-column
          prop="partyMemberDues"
          align="center"
          label="缴纳党费(元)">
          <template slot-scope="scope">
            <span style="color: red;">{{ scope.row.partyMemberDues | formatToFixed2('元') }}</span>
            <span>{{ scope.row.firstPay === 0 ? '(补)' : '' }}</span>
          </template>
        </el-table-column>
      </el-table>
    </hx-table-result>
  </div>
</template>

<script>
import Vue from 'vue';
export default {
  data () {
    return {
      id: '',
      detailLoading: false,
      listParams: {
        status: '',
        paymentMonth: '',
        payment: '',
        paymentMember: '',
        allMember: '',
        endDate: ''
      },
      pager: {
        total: 0,
        pageIndex: 1,
        pageSize: 30
      },
      tableLoading: false,
      tableData: [],
      paymentStatus: 0,
      isDisabled: false
    };
  },
  mounted () {
    this.id = this.$route.query.id;
    if (this.id) {
      this.loadDetailData(this.id);
      this.loadDetailTableList(this.paymentStatus);
    }
  },
  methods: {
    /**
       * 加载详情页数据
       * @param id
       */
    loadDetailData (id) {
      Vue.ajaxGet(this, global.apiUrl + '/partyFee/getPaymentMonthDetail', { id: id }, 'detailLoading').then((res) => {
        this.listParams = res;
      });
    },
    /**
       * radio的change事件
       * @param val
       */
    changeRadio (val) {
      this.loadDetailTableList(val);
    },
    /**
       * 加载详情页列表数据
       * @param paymentStatus
       */
    loadDetailTableList (paymentStatus) {
      const bodyParams = Object.assign({}, {
        id: this.id,
        paymentStatus: paymentStatus,
        pageIndex: this.pager.pageIndex,
        pageSize: this.pager.pageSize
      });
      Vue.ajaxGet(this, global.apiUrl + '/partyFee/getPaymentMonthById', bodyParams, 'tableLoading').then((res) => {
        this.tableData = res.dataList;
        this.pager.total = res.total;
      });
    },
    /**
       * pageIndex的change事件
       * @param val
       */
    handleCurrentChange (val) {
      this.pager.pageIndex = val;
      this.loadDetailTableList(this.paymentStatus);
    },
    /**
       * pageSize的change事件
       * @param val
       */
    handleSizeChange (val) {
      this.pager.pageSize = val;
      this.loadDetailTableList(this.paymentStatus);
    },
    /**
       * 一键提醒
       */
    remindPayment () {
      this.isDisabled = true;
      Vue.ajaxPost(this, global.apiUrl + '/partyFee/remind', { id: this.id }).then((res) => {
        this.$message.success(res.info);
        this.isDisabled = false;
      });
    }
  }
}
</script>

<style lang="less" scoped>
  .home-container{
    .alert-text{
      color: #E9A021;
      cursor: default;
    }
    .hx-form-container {
      .detail-info-layout {
        display: flex;
        .status-style{
          padding: 20px;
        }
        .form-label-style{
          padding: 10px;
        }
      }
    }
    .text-green{
      color: green;
    }
    .text-red{
      color: red;
    }
  }
</style>
